import ContactForm from "../components/ContactForm/ContactForm";
import Team from "../components/Card/Team";
import TextPage from "../components/Pages/TextPage";
import privacyContent from "./PrivacyContent";
import Slides from "../components/Slides/Slides";

const pageContent = {
  // Our Firm Section
  "our firm": {
    imageClass: "hero bg-hero1",
    title: "Our Firm",
    text: "Propertunity is a private equity fund that supports real estate investors in America.",
    subLinks: [
      { title: "About Propertunity", slug: "about-us" },
      { title: "Our People", slug: "our-people" },
      { title: "Contact", slug: "contact-us" }
    ]
  },

  // About Us subpages
  "": {
    imageClass: "hero bg-hero2",
    title: " ",
    // text: "This is homepage",
    customContent: Slides
  },
  
  // About Us subpages
  "our-people": {
    imageClass: "hero bg-hero2",
    title: "Our People",
    text: "Meet the dedicated team behind Propertunity, bringing decades of experience in real estate investment.",
    customContent: Team
  },
  
  // Our Business Section
  // "business": {
  //   imageClass: "hero bg-hero3",
  //   title: "Our Business",
  //   text: "Our business focuses on equity and fixed income portfolios underpinned by real estate investments.",
  //   subLinks: [
  //     { title: "Equity", slug: "equity" },
  //     { title: "Fixed Income", slug: "bonds" },
  //     { title: "Investments", slug: "investments" }
  //   ]
  // },
  
  // // Business subpages
  // "equity": {
  //   imageClass: "hero bg-hero4",
  //   title: "Equity Investments",
  //   text: "Our equity portfolio consists of carefully selected properties with high growth potential across diverse markets.",
  // },
  
  // "bonds": {
  //   imageClass: "hero bg-hero9",
  //   title: "Fixed Income",
  //   text: "Our fixed income strategies provide stable returns with measured risk through real estate-backed securities.",
  // },
  
  // "investments": {
  //   imageClass: "hero bg-hero1",
  //   title: "Investment Strategy",
  //   text: "Propertunity employs a data-driven approach to identify undervalued properties in emerging markets.",
  // },
// Lending Section
"lending": {
  imageClass: "hero bg-hero3",
  title: "Lending",
  text: "We provide tailored financing solutions for real estate investors, helping them acquire, renovate, and hold income-producing properties across the United States.",
  subLinks: [
    { title: "Fix & Flip", slug: "fix-flip-loans" },
    { title: "Ground Up", slug: "ground-up" },
    { title: "Stabilized", slug: "stabilized-bridge-loans" },
    { title: "Rental Unit", slug: "single-property-rental-loans" },
    { title: "Rental Portfolios", slug: "rental-portfolios-term-loans" },
  ]
},

// Lending subpages

"fix-flip-loans": {
  imageClass: "hero bg-hero4",
  title: "Fix & Flip Loans",
  text: `Short-term financing for residential 1-4 unit properties, ideal for investors purchasing and renovating properties for resale.

Key Details:
- **Loan Amount:** $50,000 – $3,000,000
- **Term:** 12 months standard, 18 months case-by-case
- **Maximum Loan-to-Cost (LTC):** Up to 90% of purchase price
- **Maximum Loan-to-Value (LTV):** Up to 75% ARLTV
- **Experience Required:** No prior experience required
- **Recourse:** Full recourse only`
},

"ground-up": {
  imageClass: "hero bg-hero7",
  title: "Ground Up",
  text: `Bridge Loans Short-term bridge financing for investors developing or constructing 1-4 unit residential properties, including small developments.  

Key Details:
- **Loan Amount:** $50,000 – $3,000,000
- **Property Count:** 1-10 properties (typically 1-2 per project for small developments)
- **Permitted Property Types:** Non-owner occupied 1-4 unit residential, townhomes, condos
- **Ineligible Property Types:** Mixed-use, 5+ unit multifamily, condotels, co-ops/TICs, commercial, log homes, properties with oil/gas leases, farms/ranches/orchards, vacation/seasonal rentals, rural properties
- **Term Length:** 12–24 months
- **Maximum Loan-to-Cost (LTC):** Up to 75% of the lower of land value or purchase price (60% if unpermitted), plus 100% of construction; catch-up draw to reach 75% at approval of required plans/permits
- **Maximum Loan-to-ARV:** Up to 70%
- **Experience Required:** Previous real estate experience; typically 3+ similar ground-up builds or heavy rehabs. Guarantors without experience may be permitted with an experienced co-guarantor
- **Recourse:** Full recourse`
},
"stabilized-bridge-loans": {
  imageClass: "hero bg-hero2",
  title: "Stabilized Bridge Loans",
  text: `Designed to provide short-term bridge financing for residential 1-4 unit properties that have been recently renovated or constructed, or are currently/rented or soon to be rented.  

Key Details:
- **Purpose:** Bridge financing for properties listed for sale or stabilized rental properties not yet ready for permanent financing.
- **Property Types:** Single family, 2-4 unit, townhomes, PUDs, warrantable condos.
- **Loan Amount:** $50,000 – $3,000,000
- **Term Length:** 12 months
- **Maximum Loan-to-Cost:** 85% of purchase price + verified completed capex (if property owned <6 months)
- **Maximum Loan-to-Value:** 70% LTV
- **Minimum FICO:** 660
- **Minimum DSCR:** N/A for sale; 1.10 exit DSCR for rental
- **Property Condition:** C2 or better (sale), C4 or better with no deferred maintenance (rental)
- **Collateral Restrictions:** Property value within 90th percentile of market; no rural, exotic, or unique properties.`
},
// Lending subpage: Single Property Rental Term Loans
"single-property-rental-loans": {
  imageClass: "hero bg-hero5",
  title: "Single Property Rental Term Loans",
  text: `Long-term financing for residential 1-4 unit properties, ideal for buy-and-hold investors.  

Key Details:
- **Minimum Loan Amount:** $75,000 – $2,000,000
- **Property Types:** Single family residences, 2-4 unit properties, townhomes, PUDs, warrantable condos
- **Term:** Up to 30 years
- **Rate Types:** Fixed or adjustable rate options available
- **Maximum Loan-to-Cost:** If owned <3 months, up to 80% of total cost basis
- **Maximum Loan-to-Value (LTV):** Up to 80% on purchase and rate & term, up to 75% on cash-out
- **Experience Required:** None
- **Minimum FICO:** 660
- **Recourse:** Full recourse only
- **Lease Requirements:** Leased units: lower of in-place rent or market rent; unleased units: 90% of market rent`
},

"rental-portfolios-term-loans": {
  imageClass: "hero bg-hero6",
  title: "Rental Portfolios Term Loans",
  text: `Long-term financing designed for investors holding multiple rental properties (1-4 units each), ideal for portfolio growth.  

Key Details:
- **Loan Amount:** Minimum property value: $72,000, Maximum loan amount: $2,000,000
- **Property Types:** Non-owner occupied single family residences, 2-4 unit properties, townhomes, PUDs, warrantable condos
- **Maximum Loan-to-Value (LTV):** Up to 80% on purchase and rate/term, up to 75% on cash-out
- **Minimum FICO:** 680
- **Minimum Debt Service Coverage Ratio:** 1.05x (Net cash flow / debt service)
- **Recourse:** Full recourse with pledge of equity of borrowing entity
- **Lease Requirements:** Minimum occupancy rate of 90% by unit count. Leased units: lower of in-place or market rent; unleased units: 90% of market rent.`
},


  // Our Impact Section
  "impact": {
    imageClass: "hero bg-hero2",
    title: "Our Impact",
    text: "We put our energy towards making the healing faster and more efficient in distressed communities.",
    subLinks: [
      { title: "Community", slug: "community" },
      { title: "Owners", slug: "owners" }
    ]
  },
  
  // Impact subpages
  "community": {
    imageClass: "hero bg-hero3",
    title: "Community Impact",
    text: "Our investments generate positive social outcomes by revitalizing neighborhoods and creating jobs.",
  },
  
  "owners": {
    imageClass: "hero bg-hero9",
    title: "Property Owners",
    text: "We partner with property owners to maximize value while maintaining community integrity.",
  },

  // Compliance Section - Uncommented
  // "compliance": {
  //   imageClass: "hero bg-hero10", 
  //   title: "Compliance",
  //   text: "We prioritize regulatory adherence and ethical investment practices in every transaction.",
  //   subLinks: []
  // },

  // Contact Us Section
  "contact-us": {
    imageClass: "hero bg-hero4",
    title: "Contact Us",
    text: "We'd love to hear from you. Reach out to discuss opportunities or ask questions.",
    customContent: ContactForm,
    subLinks: []
  },

  // Privacy Policy Section
  "privacy": {
    imageClass: "hero bg-hero2",
    title: "Privacy Policy",
    text: "We are committed to protecting your privacy and handling data responsibly.",
    customContent: () => <TextPage sections={privacyContent} />,
    subLinks: []
  }
};

export default pageContent;